import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="modal-dialog"
export default class extends Controller {
  static values = {
    open: { type: Boolean, default: false },
  }

  static targets = ["dialog", "header", "body"]

  initialize() {
    this.headerTarget.insertBefore(this.closeBtn(), this.headerTarget.firstChild);
  }

  closeBtn() {
    const closeBtn = document.createElement("button");
    closeBtn.setAttribute("type", "button");
    closeBtn.setAttribute("class", "close-btn");
    closeBtn.setAttribute("aria-hidden", "true");
    closeBtn.innerHTML = "×";
    closeBtn.addEventListener("click", () => { this.close(); });
    return closeBtn;
  }

  connect() {
    if (this.openValue) {
      this.open();
    }
    document.addEventListener("turbo:before-render", this.forceClose);
  }

  disconnect() {
    document.removeEventListener("turbo:before-render", this.forceClose);
  }

  open() {
    this.dialogTarget.showModal();
  }

  close() {
    this.dialogTarget.close();
  }

  backdropClose(event) {
    if (event.target === this.dialogTarget) {
      this.close();
    }
  }

  forceClose() {
    this.dialogTarget.close();
  }

  updateBody(body) {
    this.bodyTarget.innerHTML = body;
  }

  updateBodyFromAjax(event) {
    const [xhr, status] = event.detail;
    this.updateBody(xhr.response)
  }
}
